export type SnActionDisableExpression<D> = (data?: D) => boolean;
